<template>
  <component :is="logo" :class="classes" />
</template>

<script>
import Reddit from './svg/Reddit'
import Trustpilot from './svg/Trustpilot'
import Reviewsio from './svg/Reviewsio'

export default {
  components: {
    Reddit,
    Trustpilot,
    Reviewsio
  },

  props: {
    name: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: 'medium'
    }
  },

  computed: {
    logo () {
      return this.name.charAt(0).toUpperCase() + this.name.slice(1)
    },

    classes () {
      return ['commonExternalLogo', `commonExternalLogo_${this.size ? this.size : 'medium'}`]
    }
  }
}
</script>

<style lang="scss" scoped>
.commonExternalLogo {

  &_medium {
    height: 24px;
  }

  &_large {
    height: 32px;
  }
}
</style>
